import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import './NotificationBell.css';

function NotificationBell() {
  const [isClicked, setIsClicked] = useState(false);
  const [hasNewExam, setHasNewExam] = useState(true); // For demo, assume there's always a new exam
  const navigate = useNavigate();
  const location = useLocation();

  // Load clicked state from localStorage on component mount
  useEffect(() => {
    const clickedState = localStorage.getItem('notificationBellClicked');
    if (clickedState === 'true') {
      setIsClicked(true);
    }

    // In a real app, you would fetch from API to check if there are new exams
    // For now, we'll simulate having a new exam
    const hasNewExamFromStorage = localStorage.getItem('hasNewExam');
    if (hasNewExamFromStorage !== null) {
      setHasNewExam(hasNewExamFromStorage === 'true');
    }
  }, []);

  const handleClick = (event) => {
    // If Shift key is held while clicking, reset the bell state (for testing)
    if (event.shiftKey) {
      setIsClicked(false);
      localStorage.removeItem('notificationBellClicked');
      // Also reset hasNewExam to true for testing
      localStorage.setItem('hasNewExam', 'true');
      setHasNewExam(true);
      console.log('Notification bell reset for testing');
      return;
    }

    if (!isClicked && hasNewExam) {
      // Mark as clicked and navigate to notifications page
      setIsClicked(true);
      localStorage.setItem('notificationBellClicked', 'true');
      navigate('/notifications');
    } else {
      // If already clicked or no new exam, just navigate to notifications
      navigate('/notifications');
    }
  };

  // Don't show the bell on authentication pages
  const hideOnPaths = [
    '/login',
    '/esqueciasenha',
    '/cadastro',
    '/redefinir_senha.php',
    '/redefinir_senha'
  ];
  
  // Also hide on any path starting with /redefinir_senha/
  const shouldHide = hideOnPaths.includes(location.pathname) || 
                     location.pathname.startsWith('/redefinir_senha/');

  // If there's no new exam or we're on an auth page, don't show the bell
  if (!hasNewExam || shouldHide) {
    return null;
  }

  return (
    <div
      className={`notification-bell ${isClicked ? 'clicked' : 'unclicked'}`}
      onClick={handleClick}
      title={isClicked ? "View notifications (Shift+click to reset)" : "New notifications available! Click to view (Shift+click to reset)"}
    >
      <NotificationsIcon
        fontSize="large"
        className="bell-icon"
      />
      {/* Small indicator for testing */}
      {/* <div className="test-indicator">
        T
      </div> */}
    </div>
  );
}

export default NotificationBell;
